module.exports = __webpack_public_path__ + "img/群智.46cbdda8.png";